import axiosInstance from './request';
import keycloakService from '@/services/KeycloakService';
import { notify } from '@kyvg/vue3-notification';
import { generateTraceId } from '@/services/trace'
import debugStorage from '@/services/debugStorage';

const setup = () => {
    axiosInstance.interceptors.request.use(
        (config) => {
            const traceId = generateTraceId();
            const spanId = generateTraceId();
            config.headers['x-b3-traceid'] = traceId;
            config.headers['x-b3-spanid'] = spanId;
            config._traceId = traceId;
            config._spanId = spanId;

            const keycloak = keycloakService(); // получаем один раз
            const token = keycloak.getToken();
            const roles = keycloak.userRoles();

            const isReadonly = roles.includes('ROLE_READONLY');
            const isGetRequest = config.method?.toLowerCase() === 'get';

            if (isReadonly && !isGetRequest) {
                return Promise.reject(new Error('Access denied: ROLE_READONLY can only perform GET requests.'));
            }

            if (token) {
                config.headers['Authorization'] = 'Bearer ' + token;
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );


    axiosInstance.interceptors.response.use(
        (res) => res,
        async (err) => {
            const { response, config } = err;

            if (response?.status === 401) {
                return keycloakService().updateToken(() => {
                    config.headers.Authorization = `Bearer ${keycloakService().getToken()}`;
                    return axiosInstance(config);
                });
            }

            if (response?.status !== 200 && response?.status !== 401) {
                let errorObj = {
                    requestedUrl: err.request?.responseURL,
                    traceId: err.config._traceId,
                    spanId: err.config._spanId,
                    responseError: err.response?.data?.error,
                    responseStatus: err.response?.data?.status,
                };

                debugStorage.add(`request-${errorObj.traceId}`, errorObj)
            }

            notify({
                group: 'errors',
                title: err.name || 'Error',
                text: err.message || 'Unknown error occurred'
            });

            return Promise.reject(err);
        }
    );
};

export default setup;
